import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TFMService } from 'app/mock-api/tfm.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-commissionchange-dialog',
  standalone: true,
  imports: [NgIf,FormsModule,MatIconModule,MatSlideToggleModule],
  templateUrl: './commissionchange-dialog.component.html',
  styleUrl: './commissionchange-dialog.component.scss'
})
export class CommissionchangeDialogComponent {
  public view : any = {
    // service: {
    //   supplier: '',
    //   service: '',
    //   cost: null,
    //   exchangeRateCurrent: null,
    //   price: null,
    //   start: null,
    //   end: null,
    //   adultCount: null,
    //   teenCount: null,
    //   childCount: null,
    //   infantCount: null,
    //   internalNote: '',
    //   chk1: false
    // }
  };
  agentCommission: any;
  consultantCommission: any;
  LoggedInUser: any;

  constructor(private _tfmService: TFMService,@Inject(MAT_DIALOG_DATA) public data: any,private dialog: MatDialog,public dialogRef: MatDialogRef<CommissionchangeDialogComponent>){
    this._tfmService.getLoggedInUser().subscribe(res => {
      this.LoggedInUser = res;
    });
    console.log("data : ",this.data);
    this.view.service = this.data
  }

  close(): void {
    this.dialogRef.close();
  }
  saveServiceItem() {
    if (this.view.service) {
      console.log("Save service item", this.view.service);

      if (this.view.service.id > 0) {
        this._tfmService.filterAndSend(this.view.service._links, "edit", this.view.service).subscribe(res => {
          console.log("Service updated");
          this.dialogRef.close();
          this.openConfirmationModal({
            title: 'Service updated',
            message: 'The service has been updated successfully',
            showClose: true,
            showViewQuotes: false,
            showNewQuote: false
          });
        


          // this._itinOptionsLoad();
        });
      }
      else {
        if (this.data.guid) {
          this.view.service.searchType = 1;
          this._tfmService.getItin(this.data.guid).subscribe((res) => {
            console.log('Response:', res);
        
            let link = this._tfmService.getLink(res.content.itinerary._links, "add-item-custom");
            console.log('link',link)
        
            if (link) {
                link.href = link.href.replace("{itineraryId}", res.id);
        
                this._tfmService.send(link, this.view.service).subscribe(
                    (response) => {
                        console.log('Send Response:', response);
                        this.dialogRef.close();

                    },
                    (error) => {
                        console.error('Send Error:', error);
                    }
                );
            } else {
                console.error('Link not found: add-item-custom');
            }
        });
        }
      }
    }
  }
  openConfirmationModal(config?: { title?: string; message?: string; showClose?: boolean; showViewQuotes?: boolean; showNewQuote?: boolean;}) {
        this.dialog.open(ConfirmationDialogComponent, {
          data: config
        });
      }
  

}
